import { takeEvery, call, put } from '@redux-saga/core/effects';
import { getHealthStatusData, getHealthStatusError } from 'Actions/getHealthStatusAction';
import axios from 'axios';
import { X_API_KEY } from 'config';
import { getHealthMatrixApi } from 'consents/apis';

export function* watchGetHealthStatus() {
    yield takeEvery('GET_HEALTH_STATUS_ACTION', handleGetHealthStatus);
}

function* handleGetHealthStatus() {
    try {
        const data = yield call(fetchHealthStatus);
        yield put(getHealthStatusData(data));
    } catch (error) {
        yield put(getHealthStatusError(error?.message || 'Failed to fetch health status'));
    }
}

const fetchHealthStatus = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(getHealthMatrixApi, {
            params: { resource: 'vivre-dev' },
            headers: {
                "x-api-key": X_API_KEY,
                ...(token && { "Authorization": token })
            }
        });
        return response.data || {};
    } catch (err) {
        console.error('Failed to fetch health status:', err?.message || err);
        throw err;
    }
};
